import { Pipe, PipeTransform } from '@angular/core';
export class TdTimeDifferencePipe implements PipeTransform {
/**
 * @param {?} start
 * @param {?} end
 * @return {?}
 */
transform(start: any, end: any): string {
    let /** @type {?} */ startTime: Date = new Date(start);
    let /** @type {?} */ endTime: Date;

    if (end !== undefined) {
      endTime = new Date(end);
    } else {
      endTime = new Date();
    }

    if (!startTime.getTime() || !endTime.getTime()) {
      return 'Invalid Date';
    }

    let /** @type {?} */ diff: number = Math.floor((endTime.getTime() - startTime.getTime()) / 1000);

    let /** @type {?} */ days: number = Math.floor(diff / (60 * 60 * 24));
    diff = diff - (days * (60 * 60 * 24));

    let /** @type {?} */ hours: number = Math.floor(diff / (60 * 60));
    diff = diff - (hours * (60 * 60));

    let /** @type {?} */ minutes: number = Math.floor(diff / (60));
    diff -= minutes * (60);

    let /** @type {?} */ seconds: number = diff;

    let /** @type {?} */ pad: string = '00';

    let /** @type {?} */ daysFormatted: string = '';

    if (days > 0 && days < 2) {
      daysFormatted = ' day - ';
    } else if (days > 1) {
      daysFormatted = ' days - ' ;
    }

    return (days > 0 ? days + daysFormatted : daysFormatted) +
     pad.substring(0, pad.length - (hours + '').length) + hours + ':' +
     pad.substring(0, pad.length - (minutes + '').length) + minutes + ':' +
     pad.substring(0, pad.length - (seconds + '').length) + seconds;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'timeDifference',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdTimeDifferencePipe_tsickle_Closure_declarations() {
/** @type {?} */
TdTimeDifferencePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdTimeDifferencePipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
